import styles from './styles.module.css';

const ListadoSecciones = (props) => {
    const { sections } = props;
    
    return (
        <div className={`${styles['list-sections']}`}>
            <ul>
                {sections && sections.map( (section, key) => (
                    <li key={`listado-secciones-${key}`}>
                        <a href={`#${section.id}`}> { section.name } </a>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default ListadoSecciones;
